import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=f8761cde&scoped=true"
import script from "./bindEmail.vue?vue&type=script&lang=js"
export * from "./bindEmail.vue?vue&type=script&lang=js"
import style0 from "./bindEmail.vue?vue&type=style&index=0&id=f8761cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8761cde",
  null
  
)

export default component.exports